import * as page from '../pages.js';
import WatchlistButtons from '../includes/watchlist-buttons.js';
import initTooltips from '../includes/tooltips.js';

async function loadSectionCallback(sectionDiv, activeRoute, response, data) {
	if (data.ajax) {
		const loading = document.getElementById('section-main-loading');

		loading.insertAdjacentHTML('beforebegin', response.html);
		loading.remove();
	}

	if (response.limitPopup) {
		$("#freeSearchModal").modal('show');
	}

	if (response.hasOwnProperty('hasAccess') && response.hasAccess == false) {
		section = 'pricing';
	}

	console.log("section loaded: .section-" + activeRoute);
	WatchlistButtons.init(sectionDiv);

	if (response.hasOwnProperty('paywall')) {
		return;
	}

	if (response.hasOwnProperty('email_verify')) {
		sectionDiv.find('#emailVerifyResend').on('click', function(e) {
			e.preventDefault();

			const button = $(this);

			button.button('loading');

			ajax('verifyEmailResend', {}, function(res) {
				button.button('reset');
				alert('Your verification email has been resent;  please check your email!');
			});
		});
		return;
	}

	await page.loadPage(activeRoute, response, sectionDiv, data);

	initTooltips();
}

export default async function main() {
	const sectionDiv = $(".content-main");
	const data = window.sectionData;
	const activeRoute = sectionData.section;
	data.query = {};

	const { searchParams } = new URL(location);

	for (const entry of searchParams.entries()) {
		data.query[ entry[0] ] = entry[1];
	}

	const response = await window.sectionResponse;
	await loadSectionCallback(sectionDiv, activeRoute, response, data);
};
